import {Routes} from '@angular/router';
import {TermsPage} from './pages/terms-page/terms-page';

export const TERMS_ROUTES: Routes = [
  {
    path: '',
    component: TermsPage
  }
]
